export const validateEmail = (email: string) => {
  const emailRegex = /\S+@\S+\.\S+/;
  if (!emailRegex.test(email)) return "Are you sure that's your email?";
  return null;
};
